module.exports = __webpack_public_path__ + "static/media/bubble.2557667a.svg";